// "Powered by" footer used on the auth screens: the product credit, and only
// that. Centralised here so the wording can never drift across the auth pages.
//
// It used to print a second line, "Powered by {tenant}", above this one. That
// line credited the tenant for its OWN sign-in page — whose name and logo the
// page already leads with (SignInBrandLogo) — so it was removed; the product
// credit is the one worth keeping.
//
// The product name is a ProductLink to PRODUCT_URL, in a new tab so an auth
// flow in progress is not navigated away from. It renders in this footer's
// slate-600 uppercase text (slate-500 on the #F7F6EF sign-in ground is only
// 4.39:1). It has no underline, so its semibold weight against the regular
// "Powered by" is what marks it as a link at rest; it also dims on hover, has
// a focus ring, and a screen-reader-only "(opens in a new tab)". It looks the
// same inside SignInHelp too: SignInHelp's green semibold link rules
// exclude `[data-product-link]`.
import { ProductLink } from './ProductLink.tsx';

export function PoweredByFooter() {
  return (
    <div className="text-[10px] uppercase tracking-[0.2em] text-slate-600">
      Powered by <ProductLink className="font-semibold" />
    </div>
  );
}
